import React from 'react';
import { AnimatedBox } from '../Box';
import type { ViewStyle } from 'react-native';
import type { IOpacity } from './skeleton';

interface IProps extends IOpacity {
  style: ViewStyle;
}

export const CustomItem = ({ opacity, style }: IProps) => {
  return (
    <AnimatedBox
      backgroundColor="gray25"
      borderRadius={4}
      opacity={opacity}
      style={style}
    />
  );
};
